<template>
  <!-- FORM -->
  <v-card
    v-if="isRegistering"
    class="colorDominant pb-0"
    style="max-width: 600px"
  >
    <v-card-text
      class="pa-0"
      :class="{
        'pb-4': $vuetify.breakpoint.smAndUp,
        'pt-4': $route.name == 'player-from-agent' || $route.name == 'Register',
      }"
    >
      <v-toolbar
        v-if="!hideToolbarDialog"
        class="elevation-0 colorDominant flex-grow-0"
        height="64"
        flat
      >
        <div class="flex-grow-1"></div>
        <Login :urlRedirect="urlRedirect" />
        <v-btn class="ml-2" icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="d-flex flex-column align-center mb-4 mt-n2">
        <div
          class="d-flex cursor-pointer align-center mb-1"
          :style="
            `
            background-image: url(${$operatorLogoUrl(domain)});
            background-repeat: no-repeat;
            background-position: center center;
            background-size: contain;
            height: 36px;
            width: 100px;
            z-index: 1;
          `
          "
        ></div>

        <div class="text-body-1 white--text">
          {{ $t("newRegister.registerToBet") }}
        </div>
      </div>

      <v-form
        v-model="validFormRegister"
        class="mt-2"
        ref="refFormRegister"
        lazy-validation
        autocomplete="off"
      >
        <div
          id="form"
          :class="$vuetify.breakpoint.width < 350 ? 'px-2' : 'px-5'"
          style="margin: 0 auto"
        >
          <!-- Alert "Indicado por NOMEDOAFILIADO" -->
          <v-alert
            v-if="hideAffiliateName === false && affiliateName"
            class="mb-6"
            :icon="false"
            border="left"
            color="blue"
            dense
            text
          >
            <v-progress-circular
              v-if="affiliateProgress"
              :size="18"
              indeterminate
            ></v-progress-circular>

            <div v-if="!affiliateProgress">
              <span class="white--text mr-1">{{ $t("indicatedBy") }}</span>
              <span class="white--text">
                <strong>{{ affiliateName }}</strong>
              </span>
            </div>
          </v-alert>

          <!-- DOCUMENTO CPF (APENAS BRASIL, PARA CREDITO ONLINE!) | Birthdate -->
          <div
            :class="{
              'd-flex align-baseline': !$vuetify.breakpoint.xsOnly,
            }"
          >
            <v-col
              class="pa-0"
              :class="{
                'pr-2': !$vuetify.breakpoint.xsOnly,
              }"
              :cols="$vuetify.breakpoint.xsOnly ? 12 : 6"
            >
              <v-text-field
                v-if="$isCreditOnline()"
                v-model="cpf"
                class="field"
                label="CPF"
                ref="refCpf"
                :rules="[rules.required, rules.docCPF, rules.validateCPF]"
                v-mask="'###.###.###-##'"
                outlined
                required
                :loading="loadingDoc"
                type="tel"
                :error-messages="errorMessageDoc"
                :error="errorActiveDoc"
                dense
                tabindex="0"
                :disabled="loading || loadingDoc"
                @paste="onCpfPaste"
                @blur="focusIconField.cpf = false"
                @focus="focusIconField.cpf = true"
              >
                <template slot="append">
                  <v-icon
                    size="20"
                    :color="
                      errorActiveDoc
                        ? 'red'
                        : focusIconField.cpf
                        ? 'primary'
                        : ''
                    "
                  >
                    mdi-account-circle
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col class="pa-0" :cols="$vuetify.breakpoint.xsOnly ? 12 : 6">
              <v-text-field
                v-model="birthdate"
                class="field"
                ref="refBirthdate"
                :label="$t('dateOfBirth')"
                :rules="[rules.required, rules.birthdate]"
                placeholder="DD/MM/YYYY"
                required
                clearable
                type="tel"
                outlined
                v-mask="'##/##/####'"
                dense
                tabindex="0"
                :disabled="loading"
                @blur="focusIconField.birthdate = false"
                @focus="focusIconField.birthdate = true"
              >
                <template slot="append">
                  <v-icon
                    size="20"
                    :color="
                      birthdateError
                        ? 'red'
                        : focusIconField.birthdate
                        ? 'primary'
                        : ''
                    "
                  >
                    mdi-calendar-month
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
          </div>

          <!-- APENAS CARTOLA.BET (**** FEITO PARA O COMPLIANCE ****) -->
          <div v-if="$domain() === 'cartola'">
            <v-text-field
              outlined
              class="field"
              required
              dense
              :label="$t('personalDataFullName')"
              v-model="fullName"
              :rules="[rules.required]"
            ></v-text-field>

            <v-text-field
              outlined
              class="field"
              required
              dense
              :label="$t('addressDataAddress')"
              v-model="address"
              :rules="[rules.required]"
            ></v-text-field>
          </div>
          <!-- APENAS CARTOLA.BET (**** FEITO PARA O COMPLIANCE ****) -->

          <!-- E-MAIL -->
          <v-text-field
            v-if="!$permissions().registerSMS"
            v-model="email"
            class="field"
            ref="refEmail"
            :rules="[
              rules.invalid,
              rules.required,
              rules.validateEmailDomain,
              rules.max,
            ]"
            clearable
            outlined
            type="email"
            :error-messages="errorMessageEmail"
            :error="errorActiveEmail"
            name="newEmail"
            autocapitalize="off"
            dense
            tabindex="0"
            :loading="loadingEmail"
            :disabled="loading || loadingEmail"
            :counter="50"
            @blur="focusIconField.email = false"
            @focus="focusIconField.email = true"
          >
            <template slot="label">
              <div class="d-flex align-center">
                {{ $t("newRegister.emailLabel") }}

                <v-tooltip top content-class="tooltip">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="ml-1" color="blue" small>
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span>{{ $t("newRegister.emailLabelTooltip") }}</span>
                </v-tooltip>

                {{ ")" }}
              </div>
            </template>
            <template slot="append">
              <v-icon
                size="20"
                :color="
                  errorActiveEmail
                    ? 'red'
                    : focusIconField.email
                    ? 'primary'
                    : ''
                "
              >
                mdi-email
              </v-icon>
            </template>
          </v-text-field>

          <!-- CONFIRM E-MAIL -->
          <!-- <v-text-field
            v-if="!$permissions().registerSMS"
            v-model="emailConfirmation"
            class="field"
            :rules="[rules.required, rules.validateEmailConfirmation]"
            :label="$t('confirmEmail')"
            ref="refEmailConfirmation"
            clearable
            outlined
            type="email"
            name="confirmNewEmail"
            autocapitalize="off"
            dense
            tabindex="0"
            :disabled="loading || loadingEmail"
            @blur="focusIconField.confirmEmail = false"
            @focus="focusIconField.confirmEmail = true"
          >
            <template slot="append">
              <v-icon
                size="20"
                :color="
                  emailConfirmationError
                    ? 'red'
                    : focusIconField.confirmEmail
                    ? 'primary'
                    : ''
                "
              >
                mdi-email-check
              </v-icon>
            </template>
          </v-text-field> -->

          <!-- TELEFONE -->
          <v-text-field
            v-model="phone"
            class="field"
            ref="phone"
            :rules="[rules.required, ...phoneRule]"
            v-mask="maskPhone"
            :label="$t('phone')"
            :placeholder="placeholderPhone"
            required
            clearable
            outlined
            type="tel"
            :loading="validatePhoneLoading"
            :error="phoneError"
            :error-messages="phoneErrorMessage"
            dense
            tabindex="0"
            :disabled="loading || validatePhoneLoading"
            v-on="$isCreditOnline() ? { change: validatePhone } : {}"
            @blur="focusIconField.phone = false"
            @focus="focusIconField.phone = true"
          >
            <template slot="append">
              <v-icon
                size="20"
                :color="
                  phoneError ? 'red' : focusIconField.phone ? 'primary' : ''
                "
              >
                mdi-phone
              </v-icon>
            </template>
          </v-text-field>

          <!-- PASSWORD -->
          <v-text-field
            v-model="password"
            class="field"
            :class="[show1 ? 'show-password' : 'hide-password']"
            ref="password"
            type="text"
            :label="$t('password')"
            :rules="[rules.required]"
            required
            clearable
            outlined
            :counter="12"
            maxlength="12"
            autocapitalize="off"
            dense
            tabindex="0"
            :disabled="loading"
            :hide-details="focusIconField.password"
            :error="passwordError"
            @blur="focusIconField.password = false"
            @focus="focusIconField.password = true"
          >
            <template slot="append">
              <v-icon
                class="pr-1"
                :color="
                  passwordError
                    ? 'red'
                    : focusIconField.password
                    ? 'primary'
                    : ''
                "
                size="20"
                tabindex="-1"
                @click="show1 = !show1"
              >
                {{ show1 ? "mdi-eye" : "mdi-eye-off" }}
              </v-icon>
              <v-icon
                :color="
                  passwordError
                    ? 'red'
                    : focusIconField.password
                    ? 'primary'
                    : ''
                "
              >
                mdi-lock
              </v-icon>
            </template>
          </v-text-field>

          <v-expand-transition>
            <PasswordRules
              v-if="focusIconField.password"
              class="mt-1 ml-3"
              :rules="passwordRules"
              registerType
            />
          </v-expand-transition>

          <!-- CONFIRM PASSWORD -->
          <!-- <v-text-field
            v-model="passwordConfirm"
            class="field"
            :class="[
              show2 ? 'show-password' : 'hide-password',
              focusIconField.password && 'mt-4',
            ]"
            type="text"
            :label="$t('confirmPassword')"
            :rules="passMatch"
            required
            :counter="12"
            maxlength="12"
            clearable
            outlined
            autocapitalize="off"
            dense
            tabindex="0"
            :disabled="loading"
            :error="confirmPasswordError"
            @blur="focusIconField.confirmPassword = false"
            @focus="focusIconField.confirmPassword = true"
          >
            <template slot="append">
              <v-icon
                class="pr-1"
                :color="
                  confirmPasswordError
                    ? 'red'
                    : focusIconField.confirmPassword
                    ? 'primary'
                    : ''
                "
                size="20"
                tabindex="-1"
                @click="show2 = !show2"
              >
                {{ show2 ? "mdi-eye" : "mdi-eye-off" }}
              </v-icon>
              <v-icon
                :color="
                  confirmPasswordError
                    ? 'red'
                    : focusIconField.confirmPassword
                    ? 'primary'
                    : ''
                "
              >
                mdi-lock
              </v-icon>
            </template>
          </v-text-field> -->

          <!-- Promotion Code -->
          <v-slide-y-reverse-transition>
            <v-text-field
              v-if="$isCreditOnline() && showPromotionCodeInput"
              v-model="promoCode.value"
              class="field"
              :label="$t('promoCode')"
              :loading="promoCode.loading"
              :error-messages="promoCode.error.message"
              :error="promoCode.error.status"
              :success="promoCode.success.message != ''"
              :success-messages="promoCode.success.message"
              clearable
              outlined
              dense
              type="text"
              tabindex="0"
              autocapitalize="off"
              :counter="20"
              maxlength="20"
              :disabled="loading || promoCode.loading"
              @keyup="onKeyUpPromoCode"
              @blur="focusIconField.promoCode = false"
              @focus="focusIconField.promoCode = true"
            >
              <template slot="append">
                <v-icon
                  size="20"
                  :color="
                    promoCode.error.status
                      ? 'red'
                      : focusIconField.promoCode
                      ? 'primary'
                      : promoCode.success.message != ''
                      ? 'green'
                      : ''
                  "
                >
                  mdi-gift-outline
                </v-icon>
              </template>
            </v-text-field>
          </v-slide-y-reverse-transition>
          <div
            v-if="!showPromotionCodeInput"
            class="d-flex justify-center align-center mb-10"
          >
            {{ $t("doYouHavePromoCode") }}
            <a
              class="
                ml-2
                px-0
              "
              @click="showPromotionCodeInput = true"
            >
              {{ $t("clickHere") }}
            </a>
          </div>

          <!-- Register Recaptcha -->
          <!-- <vue-recaptcha
            size="invisible"
            ref="invisibleRecaptcha"
            sitekey="6LeeGAYiAAAAALHUyamQVAlJAMKhEW1v2EPo5Hjx"
            @verify="onVerify"
            @expired="onExpired"
            :loadRecaptchaScript="loadRecaptcha"
          ></vue-recaptcha> -->

          <div
            class="white--text"
            style="padding: 0.5rem 0; text-align: center; font-size: 1em"
          >
            {{ $t("newRegister.agreeAdulthood") }}
            <span
              class="primary--text"
              style="cursor: pointer"
              @click="push('terms')"
            >
              {{ $t("generalTermsAndConditions") }}
            </span>
            {{ $t("newRegister.andThe") }}
            <span
              class="primary--text"
              style="cursor: pointer"
              @click="push('privacy')"
            >
              {{ $t("privacy") }} </span
            >.
          </div>

          <v-card-actions
            class="pt-4 pb-0 px-0 d-flex flex-column"
            :class="$vuetify.breakpoint.xsOnly ? 'pb-6' : 'mb-4'"
          >
            <div id="divRecaptchaWidget"></div>

            <v-btn
              id="btn_register_submit"
              block
              type="submit"
              color="primary"
              :loading="loading"
              :disabled="disableRegister"
              @click.prevent="handlerRegister"
            >
              {{ $t("register") }}
            </v-btn>
          </v-card-actions>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
  <!-- View After Register -->
  <v-card
    v-else
    class="colorDominant d-flex flex-column"
    :class="{
      'justify-between': $vuetify.breakpoint.xsOnly,
      'pt-7': $route.name == 'player-from-agent',
      'mt-0': $vuetify.breakpoint.width < 400,
    }"
  >
    <v-toolbar
      v-if="!hideToolbarDialog"
      class="elevation-0 colorDominant flex-grow-0"
      flat
      height="64"
    >
      <div class="flex-grow-1"></div>
      <v-btn class="ml-2" icon @click="closeDialog()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <div
      class="d-flex flex-column justify-center"
      :style="{
        height: $vuetify.breakpoint.width < 400 ? 'calc(100vh - 80px)' : '',
      }"
    >
      <v-card-text
        class="pa-0 d-flex flex-column justify-between"
        :class="$vuetify.breakpoint.smAndDown ? 'px-5' : 'px-10'"
      >
        <div class="d-flex flex-column align-center">
          <div
            class="d-flex align-center mb-2"
            :style="
              `
              background-image: url(${$operatorLogoUrl(domain)});
              background-repeat: no-repeat;
              background-position: center center;
              background-size: contain;
              height: 36px;
              width: 60px;
            `
            "
          ></div>

          <div
            class="d-flex flex-column text-body-1"
            style="gap: 6px; color: white; text-align: center"
          >
            <div
              v-html="
                $t('newRegister.welcome', {
                  playerName: capitalizeStr(playerName.split(' ')[0]),
                })
              "
            ></div>
            <div class="my-4">{{ $t("newRegister.infoLoginAndSupport") }}</div>
            <div v-html="$t('newRegister.makeYourDeposit')"></div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions
        class="d-flex flex-column pa-0 ma-5 mt-10"
        :class="$vuetify.breakpoint.xsOnly ? 'mb-6' : 'mb-8'"
      >
        <v-btn
          id="btn_register_submit"
          block
          type="submit"
          color="primary"
          @click.prevent="push('dialogDeposit')"
        >
          {{ $t("deposit") }}
        </v-btn>
        <v-btn
          v-if="$store.state.operators.multifactor == 1"
          class="ma-0 mt-4"
          block
          outlined
          type="submit"
          color="primary"
          @click.prevent="push('twoStepsAuthentication')"
        >
          {{ $t("twoStepsAuthTitle") }}
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
import { validate } from "@/util/form-validate";
import qs from "qs";
import Login from "@/components/login/dialog.vue";
import PasswordRules from "@/components/login/passwordRegistration/PasswordRules.vue";
// import getInfoTable from "@/util/infoTable";
// import domainsForCaptcha from "@/util/domainsForCaptcha";
import axios from "axios";
// import VueRecaptcha from "vue-recaptcha";

export default {
  name: "NewRegister",
  props: ["hideToolbarDialogProp", "urlRedirect"],
  components: {
    Login,
    PasswordRules,
    // VueRecaptcha,
  },
  data: (vm) => ({
    domain: "",
    isRegistering: true,
    validFormRegister: false,
    disabled: true,
    loading: false,
    //When user is indicated from a agent
    playerFromAffiliate: false,
    affiliateName: "",
    hideAffiliateName: false,
    affiliateProgress: true,
    affiliateCode: null, // pode ser do player-from-agent ou /ac/:campaign
    // After Register
    playerName: "",
    // DOC (CPF)
    cpf: "",
    cpfValidated: false,
    errorActiveDoc: false,
    errorMessageDoc: "",
    loadingDoc: false,
    // Birthdate
    birthdate: "",
    birthdateError: false,
    //Email
    email: "",
    acceptedEmail: "",
    errorMessageEmail: "",
    errorActiveEmail: false,
    loadingEmail: false,
    emailConfirmation: "",
    emailConfirmationError: false,
    // Phone
    phone: "",
    phoneError: false,
    phoneErrorMessage: "",
    validatePhoneLoading: false,
    placeholderPhone: "",
    maskPhone: vm.$permissions().phoneMask,
    //Password / Confirm Password
    password: "",
    passwordConfirm: "",
    passwordError: false,
    // confirmPasswordRules: {
    //   required: true,
    // },
    // confirmPasswordError: false,
    show1: false,
    show2: false,
    // Promotion Code
    showPromotionCodeInput: false,
    promoCode: {
      value: "",
      lastValuePromoRegister: "",
      lastValuePromoAffiliate: "",
      error: {
        status: false,
        message: "",
      },
      success: {
        message: "",
      },
      loading: false,
      checkIntervalId: 0,
    },
    // Terms
    terms: false,
    // Estado no foco dos campos e ativar ou não o primary no icon do campo
    focusIconField: {
      cpf: false,
      birthdate: false,
      email: false,
      confirmEmail: false,
      phone: false,
      password: false,
      // confirmPassword: false,
      promoCode: false,
    },
    // Rules
    rules: {
      required: validate.required,
      max: validate.max,
      phoneCounter: validate.phoneCounter2,
      passLength: validate.passLength,
      passCaracter: validate.passCaracter,
      validEmail: validate.validEmail,
      docCPF: validate.docCPF,
      validateCPF: validate.validateCPF,
      birthdate: validate.birthdate,
      docMax: validate.docMax,
      invalid: validate.validEmail,
      validateEmailDomain: validate.validateEmailDomain,
      // validateEmailConfirmation: () => {
      //   if (!vm.email || !vm.emailConfirmation) {
      //     return true;
      //   }

      //   return vm.email === vm.emailConfirmation
      //     ? true
      //     : vm.$t("newRegister.emailsDontMatch");
      // },
      // validatePasswordConfirmation: () => {
      //   if (!vm.password || !vm.passwordConfirm) {
      //     return true;
      //   }

      //   return vm.password === vm.passwordConfirm
      //     ? true
      //     : vm.$t("repeatThePassword");
      // },
    },
    passwordRules: {
      oneLowercaseLetter: {
        error: true,
        message: "firstPasswordRegistration.rules.oneLowerAndUppercaseLetter",
        validate: (v) => /(?=.*?[a-z])/.test(v) && /(?=.*?[A-Z])/.test(v),
      },
      oneNumber: {
        error: true,
        message: "firstPasswordRegistration.rules.oneNumber",
        validate: (v) => /(?=.*?[0-9])/.test(v),
      },
      oneSpecialCharacter: {
        error: true,
        message: "firstPasswordRegistration.rules.oneSpecialCharacter",
        validate: (v) => /(?=.*?[#?!@$%^&*-])/.test(v),
      },
      betweenEightAndTwelveCharacters: {
        error: true,
        message:
          "firstPasswordRegistration.rules.betweenEightAndTwelveCharacters",
        validate: (v) => v.length >= 8 && v.length <= 12,
      },
    },

    // Recaptcha
    recaptchaTokenRegister: "",
    loadRecaptcha: false,
    initialFormSetupTimeoutId: 0,

    // APENAS CARTOLA.BET (**** FEITO PARA O COMPLIANCE ****)
    fullName: "",
    address: "",
  }),
  beforeMount() {
    this.domain = this.$domain();

    // Ativando o captcha para os domínios definidos na lista;
    // Recaptcha Enterprise liberado para todos Operadores.
    // if (domainsForCaptcha.includes(this.domain)) {
    this.loadRecaptcha = true;
    // }

    if (this.dialog) {
      this.debouncedInitialFormSetup();
    } else if (this.$route.name === "player-from-agent") {
      this.debouncedInitialFormSetup();
    }
  },
  mounted() {
    this.disabled = true;

    // Placeholder Phone
    // IF TEMPORÁRIO (para tratamento de mask PR e BR);
    this.placeholderPhone =
      this.domain == "girosbet" ? "000 00-0000" : "(00) 90000-0000";

    this.$handleURLState("open_register", "delete");

    // Lgaming
    // Querys fornecidas pela lgaming
    if (this.$route.query.user_id && this.$route.query.affiliate_id) {
      // console.log("v 0.1.0 - lgaming");
      // Armazena em localStorage
      localStorage.setItem("lgaming_tid", this.$route.query.user_id);
      localStorage.setItem(
        "lgaming_webmaster_id",
        this.$route.query.affiliate_id
      );
    }
  },
  watch: {
    password(val) {
      if (val == null || val == "") return;

      this.checkPasswordRules();
    },
    // passwordConfirm(val) {
    //   if (val == null || val == "") return;

    //   if (typeof this.rules.required(this.passwordConfirm) === "string") {
    //     this.confirmPasswordError = true;
    //   } else if (
    //     typeof this.rules.validatePasswordConfirmation(this.password) ===
    //     "string"
    //   ) {
    //     this.confirmPasswordError = true;
    //   } else {
    //     this.confirmPasswordError = false;
    //   }
    // },
    "promoCode.value"(promoCode) {
      this.promoCode.error.status = false;
      this.promoCode.success.message = "";
      this.promoCode.error.message = "";

      if (promoCode == null || promoCode == "") {
        clearInterval(this.promoCode.checkIntervalId);

        return;
      }

      this.debouncedUserHasPromotion();
    },
    dialog(val) {
      if (val) {
        this.debouncedInitialFormSetup();
      } else if (this.$route.name == "Login") {
        this.$router.push("/");
      }
    },
    email(val) {
      this.errorMessageEmail = "";
      this.errorActiveEmail = false;

      if (val == null || val == "") {
        this.acceptedEmail = this.email;

        return;
      }

      // if (this.$refs.refEmailConfirmation.validate()) {
      //   this.emailConfirmationError = false;
      // } else {
      //   this.emailConfirmationError = true;
      // }

      if (this.$refs.refEmail.validate()) {
        this.errorActiveEmail = false;
        this.validateEmail();
        // if (this.$refs.refEmailConfirmation.validate()) this.validateEmail();
      } else {
        this.errorActiveEmail = true;
      }
    },
    // emailConfirmation(val) {
    //   if (val == null || val == "") return;
    //   this.emailConfirmationError = false;

    //   if (this.$refs.refEmailConfirmation.validate()) {
    //     this.emailConfirmationError = false;

    //     if (this.$refs.refEmail.validate()) {
    //       this.errorMessageEmail = "";
    //       this.errorActiveEmail = false;

    //       this.validateEmail();
    //     }
    //   } else {
    //     this.emailConfirmationError = true;
    //   }
    // },
    cpf(newVal, oldVal) {
      if (newVal && newVal.length < 14) {
        this.errorActiveDoc = false;
        this.errorMessageDoc = "";
      }

      if (newVal == null || newVal == "") {
        this.cpfValidated = false;

        return;
      }

      if (
        this.$refs.refCpf.validate() &&
        newVal.length == 14 &&
        oldVal.length != 15
      ) {
        this.checkCPF(newVal);
      }

      this.startRegistrationGA4(newVal);
    },
    birthdate(val) {
      if (val == null || val == "") return;
      this.birthdateError = false;

      if (this.$refs.refBirthdate.validate()) {
        this.birthdateError = false;
      } else {
        this.birthdateError = true;
      }
    },
  },
  computed: {
    disableRegister() {
      return (
        !this.statusCheckFieldsForm ||
        !this.recaptchaTokenRegister ||
        this.loading ||
        this.loadingDoc ||
        this.validatePhoneLoading ||
        this.loadingEmail ||
        this.promoCode.loading
      );
    },

    statusCheckFieldsForm() {
      let passwordError = false;

      for (const rule in this.passwordRules) {
        if (this.passwordRules[rule].error === true) {
          passwordError = true;
        }
      }

      // if (typeof this.rules.required(this.passwordConfirm) === "string") {
      //   passwordError = true;
      // } else if (
      //   typeof this.rules.validatePasswordConfirmation(this.password) ===
      //   "string"
      // ) {
      //   passwordError = true;
      // }

      const statusCheckFieldsForm =
        this.cpf &&
        this.cpfValidated &&
        !this.errorActiveDoc &&
        this.birthdate &&
        this.email &&
        this.acceptedEmail == this.email &&
        !this.errorActiveEmail &&
        this.phone &&
        !this.phoneError &&
        !passwordError &&
        this.validFormRegister && (
          (this.promoCode.value && this.promoCode.success.message) ||
          !this.promoCode.value);

      if (statusCheckFieldsForm) this.renderWidgetRecaptcha();
      return statusCheckFieldsForm;
    },

    isCheckingForActivePromotion() {
      if (!this.$isCreditOnline()) {
        return false;
      }

      if (this.promoCode.error.status) {
        return false;
      }

      return (
        this.promoCode.value != null &&
        this.promoCode.value != "" &&
        !this.promoCode.success.message
      );
    },

    dialog() {
      return this.$store.state.showDialogRegister;
    },

    hideToolbarDialog() {
      if (this.hideToolbarDialogProp) return true;

      return false;
    },
    // PHONE RULES - IF TEMPORÁRIO
    // Com regra de negócio apenas para o girosbet (paraguai).
    phoneRule() {
      return this.domain == "girosbet"
        ? [validate.phoneCounterMaskPR]
        : [validate.phoneCounterMaskBR, validate.phoneValid];
    },
    // Confirm password rules
    // passMatch() {
    //   const rules = [];

    //   let required = this.$t("required");
    //   let repeatPassWord = this.$t("repeatThePassword");

    //   // Required
    //   if (this.confirmPasswordRules.required) {
    //     const rule = (v) => !!v || required;
    //     rules.push(rule);
    //   }

    //   // Confirm Password
    //   if (this.passwordConfirm) {
    //     const rule = (v) => (!!v && v) === this.password || repeatPassWord;
    //     rules.push(rule);
    //   }

    //   return rules;
    // },
    affiliateIdStorage() {
      return (
        this.$route.params.affiliate_id || localStorage.getItem("affiliateId")
      );
    },
  },

  methods: {
    callCampaignCounter() {
      if (!this.affiliateCode) {
        return;
      }

      axios
        .post(
          `https://countclick.sga.bet/sendClick?k=${this.$domain()}-${
            this.affiliateCode
          }`
        )
        .finally(() => {
          localStorage.removeItem("callCampaign");
        });
    },
    initialFormSetup() {
      const newAffiliateCampaignCode = localStorage.getItem("affiliateCode");
      const oldAffiliateCode = this.affiliateIdStorage;
      const code = newAffiliateCampaignCode || oldAffiliateCode;

      if (this.$route.name === "player-from-agent" && oldAffiliateCode) {
        this.affiliateCode = oldAffiliateCode;
      } else if (code) {
        this.affiliateCode = code;
      }

      // Valores iniciais de código promocional de
      // Promoção de Cadastro ou Promoção de Afiliado
      this.initialPromoCodeValues();
      this.$handleURLState("open_register", "delete");
      this.isRegistering = true;

      this.recaptchaTokenRegister = "";

      const divRecaptchaToken = document.getElementById("divRecaptchaWidget");

      if (divRecaptchaToken && divRecaptchaToken.firstChild)
        divRecaptchaToken.removeChild(divRecaptchaToken.firstChild);

      if (this.statusCheckFieldsForm) this.renderWidgetRecaptcha();
    },
    push(to) {
      if (to === "dialogDeposit") {
        this.closeDialog();
        this.$store.commit("dialogDeposit", true);
        return;
      }

      if (to === "terms" || to === "privacy") {
        let route = this.$router.resolve({
          name: to,
          query: {
            action: "post",
          },
        });

        window.open(route.href, "_blank");
      }

      if (to === "twoStepsAuthentication") {
        this.$router
          .push({
            name: "Perfil",
            query: {
              tabProfile: "security",
            },
          })
          .catch(() => {});
      }
    },
    registerSuccessRedirect() {
      // page/register
      if (this.$route.name === "Register") {
        this.$router.push({ name: "RegisterSuccessPage" });
        // player-from-agent
      }
      if (this.playerFromAffiliate) {
        this.$router.push({ name: "RegisterSuccessFromAffiliate" });
      }
      // global register dialog
      else {
        const hasBt = this.$permissions().bigTable;
        const suffix = hasBt ? "Bt" : "Sports";
        this.$router.push({ name: `RegisterSuccess${suffix}` });
      }
    },
    // Registrando Evento no Google Analytics
    // De início de cadastro;
    startRegistrationGA4(cpf) {
      let start = sessionStorage.getItem("start_registration");

      if (!start) {
        this.$gtag.start_registration(cpf);
        sessionStorage.setItem("start_registration", true);
        return;
      }
    },
    // Validação do backend do recaptcha.
    // onVerify: function(response) {
    //   const headers = {
    //     "Content-Type": "application/json",
    //   };
    //   const endpoint =
    //     "https://0m5iy0epbc.execute-api.us-east-2.amazonaws.com/recaptcha";
    //   axios
    //     .post(endpoint, { token: response }, { headers: headers })
    //     .then((resp) => {
    //       const data = resp.data;
    //       if (data.success) {
    //         this.doRegister();
    //       } else {
    //         this.disabled = false;
    //         const msg = "Error de validação!";
    //         const color = "warning";
    //         this.$store.commit("setNotification", {
    //           msg,
    //           color,
    //         });
    //       }
    //     })
    //     .finally(() => this.$refs.invisibleRecaptcha.reset());
    // },
    // onExpired: function() {
    //   console.log("Expired");
    // },
    // Valores iniciais de código promocional de
    // Promoção de Cadastro ou Promoção de Afiliado
    initialPromoCodeValues() {
      if (this.$store.state.currentRegisterPromotionCode) {
        this.promoCode.value = this.$store.state.currentRegisterPromotionCode;

        this.$store.commit("resetCurrentRegisterPromotionCode");

        if (this.promoCode.lastValuePromoRegister !== this.promoCode.value) {
          this.promoCode.lastValuePromoRegister = this.promoCode.value;
        }
      } else {
        const emptyPromoValues =
          this.promoCode.lastValuePromoAffiliate == "" &&
          this.promoCode.value == "" &&
          this.affiliateCode;

        const diffPromoValues =
          this.promoCode.lastValuePromoAffiliate !== this.promoCode.value &&
          this.affiliateCode;

        if (emptyPromoValues || diffPromoValues) {
          this.promoCode.lastValuePromoAffiliate = this.promoCode.value;
          this.promoCode.value = "";
        }
      }

      this.getAffiliateData();
    },
    async getAffiliateData() {
      const code = this.affiliateCode;

      if (!code) {
        return;
      }

      if (this.affiliateName === "" && this.hideAffiliateName === false) {
        try {
          const response = await this.$axios.post(
            "/player/online/register/getNameAgent",
            this.$formdata({ agentId: code, domain: this.domain })
          );

          this.affiliateProgress = false;
          if (response.data.dados === "") {
            this.hideAffiliateName = true;
          } else {
            this.affiliateName = response.data.dados;
          }

          if (
            this.$route.query.from_campaign ||
            localStorage.getItem("callCampaign")
          ) {
            if (this.$route.name === "Sports") {
              this.$router.push({
                query: {
                  sport: "Futebol",
                  live: "Futebol",
                },
              });
            } else {
              // this.$router.replace({ query: null });
            }

            this.callCampaignCounter();
          }

          localStorage.removeItem("forceOpenRegister");
        } catch (e) {
          this.affiliateCode = null;
          localStorage.removeItem("affiliateCode");
          localStorage.removeItem("affiliateId");

          const msg = e.response.data.messages.error;
          const color = "warning";
          this.$store.commit("setNotification", {
            msg,
            color,
          });

          localStorage.removeItem("forceOpenRegister");

          return e;
        }
      }

      // Ao clicar em "Aderir promoção" será adicionado o código da promoção
      // no campo de código promocional, com isso não precisaremos requisitar
      // a promoção de afiliado
      if (this.promoCode.value) return;

      // Fetch promotion code
      this.$axios
        .post(
          "/player/online/register/getCodeByAffiliate",
          this.$formdata({
            affiliate_code: code,
            domain: this.domain,
          })
        )
        .then((res) => {
          if (
            res.data.dados.codigo &&
            res.data.dados.codigo != null &&
            res.data.dados.codigo != ""
          ) {
            this.promoCode.value = res.data.dados.codigo;
            this.promoCode.lastValuePromoAffiliate = this.promoCode.value;
          }
        })
        .catch(() => {});
    },
    debouncedUserHasPromotion() {
      clearInterval(this.promoCode.checkIntervalId);

      this.promoCode.checkIntervalId = setTimeout(() => {
        this.userHasPromotion();
      }, 500);
    },
    userHasPromotion() {
      this.promoCode.loading = true;

      this.$axios
        .post(
          "/player/bonus/promotion/registerPromotionActive",
          this.$formdata({
            code_promo: this.promoCode.value,
            domain: this.domain,
          })
        )
        .then((res) => {
          this.promoCode.error.status = false;
          this.promoCode.error.message = "";
          this.promoCode.success.message = res.data.messages;
        })
        .catch((err) => {
          this.promoCode.error.status = true;
          this.promoCode.error.message = err.response.data.messages.error;
        })
        .finally(() => {
          this.promoCode.loading = false;
        });
    },
    onKeyUpPromoCode() {
      this.promoCode.value = this.promoCode.value
        ? this.promoCode.value
            .toUpperCase()
            // Tira espaço em branco
            .replace(/\s/g, "")
        : "";
    },
    validatePhone() {
      const phone = this.phone
        ? this.phone.replace(
            /[`~!@#$%^&*()_|+\-=?;:'",.<>/( )+/\{\}\[\]\\\/]/gi,
            ""
          )
        : "";

      if (phone.length != 11) return;

      this.validatePhoneLoading = true;

      const body = { phone, domain: this.domain };
      this.$axios
        .post("/player/online/register/validatePhone", this.$formdata(body))
        .then(() => {
          this.phoneError = false;
          this.phoneErrorMessage = "";
        })
        .catch((err) => {
          this.phoneError = true;
          this.phoneErrorMessage = err.response.data.messages.error;
        })
        .finally(() => {
          this.validatePhoneLoading = false;
        });
    },
    checkCPF() {
      const cpf = this.cpf ? this.cpf.replace(/[\s.-]*/gim, "") : "";

      if (cpf.length == 11) {
        this.loadingDoc = true;
        const data = {
          domain: this.domain,
          cpf: cpf,
        };

        this.$axios
          .post("/player/online/register/fetchCpf", this.$formdata(data))
          .then(() => {
            this.cpfValidated = true;
            this.errorMessageDoc = "";
            this.errorActiveDoc = false;

            // if (!this.acceptedEmail && this.email && this.emailConfirmation) {
            if (!this.acceptedEmail && this.email) {
              this.validateEmail();
            }

            return;
          })
          .catch((error) => {
            this.cpfValidated = false;
            this.errorMessageDoc = "CPF já cadastrado!";
            this.errorActiveDoc = true;

            const msg = error.response.data.messages[0];
            const color = "warning";
            this.$store.commit("setNotification", {
              msg,
              color,
            });
          })
          .finally(() => (this.loadingDoc = false));
      } else {
        this.cpfValidated = false;
        this.errorActiveDoc = true;

        return;
      }
    },
    onCpfPaste(evt) {
      const text = evt.clipboardData.getData("text");
      if (text && text.trim().length >= 5) {
        this.cpf = text;
      }
    },
    // VALIDATE E-MAIL
    validateEmail() {
      // if (
      //   !this.emailConfirmation ||
      //   this.email !== this.emailConfirmation ||
      //   !this.email
      // )
      if (
        !this.email
      )
        return;

      const email = this.email;

      if (email.length > 0) {
        this.loadingEmail = true;

        this.checkEmail(email)
          .then(() => {})
          .catch(() => {})
          .finally(() => {
            this.loadingEmail = false;
          });
      }
    },
    // Check Email
    checkEmail(email) {
      this.disabled = true;

      return new Promise((resolve, reject) => {
        const endpoint = "player/online/register/fetchLoginAndEmailInOperator";

        this.$axios
          .post(
            endpoint,
            this.$formdata({
              email,
              domain: this.domain,
            })
          )
          .then((resp) => {
            if (this.acceptedEmail != this.email)
              this.acceptedEmail = this.email;

            this.errorMessageEmail = "";
            this.errorActiveEmail = false;

            resolve(resp);
          })
          .catch((error) => {
            this.errorMessageEmail = this.$t("emailAlreadyRegistered");
            this.errorActiveEmail = true;

            reject(error);
          });
      });
    },
    checkPasswordRules(reset) {
      if (this.password.length == 0) return false;

      let allRulesChecked = true;

      for (const rule in this.passwordRules) {
        this.passwordRules[rule].error =
          this.passwordRules[rule].validate(
            this.password ? this.password : ""
          ) === false;

        if (this.passwordRules[rule].error) allRulesChecked = false;
      }

      this.passwordError = reset ? false : !allRulesChecked;
      // this.confirmPasswordError = reset ? false : this.confirmPasswordError;

      return allRulesChecked;
    },
    handlerRegister() {
      if (this.disableRegister) return;

      if (this.loadRecaptcha) {
        this.disabled = true;

        // Ao executar o recptcha ele retorna um token e chama a função de callback "onVerify"
        // que faz a validação no backend.
        // this.$refs.invisibleRecaptcha.execute();

        if (window.grecaptcha) {
          window.grecaptcha.enterprise.ready(async () => {
            const currentTokenRecaptcha = window.grecaptcha.enterprise.getResponse();

            if (
              this.recaptchaTokenRegister &&
              this.recaptchaTokenRegister == currentTokenRecaptcha
            )
              this.doRegister();
          });
        }
      } else {
        this.doRegister();
      }
    },
    doRegister() {
      this.disabled = true;
      this.loading = true;

      // Format Birthdate American
      var formatBirthdate = this.birthdate.split("/");
      formatBirthdate = `${formatBirthdate[2]}-${formatBirthdate[1]}-${formatBirthdate[0]}`;

      let data = {
        domain: this.domain,
        email: this.email,
        email_conf: this.emailConfirmation,
        // Items apenas para o Operador Online (Credit 2)
        cpf: this.cpf.replace(/[\s.-]*/gim, ""),
        birthDate: this.$isCreditOnline() ? formatBirthdate : "",
        acceptedTerms: 1,
        // tira a mascara
        // eslint-disable-next-line no-useless-escape
        celular: this.phone.replace(
          /[`~!@#$%^&*()_|+\-=?;:'",.<>/( )+/\{\}\[\]\\\/]/gi,
          ""
        ),
        password: this.password,
        url_client: `${window.location.protocol}//${window.location.hostname}/`,
        promotion_code: this.promoCode.value,
        sending_channel: "email",
        login: this.email,
        recaptchaToken: this.recaptchaTokenRegister,
        affiliate_code: this.affiliateCode ? this.affiliateCode : "",
      };

      // APENAS CARTOLA.BET (**** FEITO PARA O COMPLIANCE ****)
      if (this.domain == "cartola") {
        data.nome = this.fullName;
        data.endereco = this.address;
      }

      this.register(data)
        .then((resp) => {
          let respData = resp.data;
          const msg = respData.messages;
          const idUser = respData.user_data.id_usuario;
          const nameUser = respData.user_data.nome_usuario;
          this.playerName = nameUser || "";
          this.$store.commit("setNotification", {
            msg,
            color: "green",
          });
          data.nome = nameUser;

          this.affiliateCode = null;
          localStorage.removeItem("affiliateId");
          localStorage.removeItem("affiliateCode");

          this.$loginAutomatic(respData);
          if (this.$store.state.logged.status) this.isRegistering = false;

          return idUser;
        })
        .then(async (idUser) => {
          // Integrations
          // Active Campaign
          this.$activeCampaign("createContact", data, idUser);
          // Webhook
          this.$webhook("sendMessage", data);
          // Zendesk
          this.$zendesk("createUser", data, idUser);
          // Rd Station
          this.$rdStation("createUser", data, idUser);

          // Lgaming
          var tid = localStorage.getItem("lgaming_tid");
          var webmaster_id = localStorage.getItem("lgaming_webmaster_id");
          if (tid && webmaster_id) {
            this.$lgaming("createUser", data, idUser, tid, webmaster_id);
          }
        })
        .then(() => {
          this.cancelForms();
        })
        .catch((err) => {
          this.NotificationErrorDefault(err);

          // Status code de erro de expiração de token
          if (err.response.data.status == 403) this.closeDialog();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // Register API
    register(data) {
      return new Promise((resolve, reject) => {
        const endpoint = this.$isCreditOnline()
          ? "/player/online/register/addPlayer"
          : "/player/register/addPlayer";
        this.$axios
          .put(endpoint, qs.stringify(data))
          .then((resp) => {
            // Register Event Google Analytics
            var method = "email";
            var id_user = resp.data.user_data.id_usuario;
            this.$gtag.pre_sign_up(method, id_user, {
              ...data,
              nome: resp.data.user_data.nome_usuario,
            });
            resolve(resp);
          })
          .catch((error) => {
            this.disabled = false;
            reject(error);
          });
      });
    },
    // Notification Error Default
    NotificationErrorDefault(error) {
      const msg = error.response.data.messages.error;
      const color = "warning";
      this.$store.commit("setNotification", {
        msg,
        color,
      });
    },
    renderWidgetRecaptcha() {
      if (this.recaptchaTokenRegister) return;

      window.grecaptcha.enterprise.ready(() => {
        if (!document.getElementById("divRecaptchaWidget").firstChild) {
          const newDivRecaptcha = document.createElement("div");
          newDivRecaptcha.setAttribute("class", "g-recaptcha mb-6");
          newDivRecaptcha.setAttribute("id", "btnRecaptchaRegister");
          newDivRecaptcha.setAttribute("data-action", "REGISTER");
          newDivRecaptcha.setAttribute(
            "data-sitekey",
            "6LeV4zcpAAAAADEJ3-lMqwX3l2TZDFybfhadIvVM"
          );

          document
            .getElementById("divRecaptchaWidget")
            .appendChild(newDivRecaptcha);

          if (document.getElementById("divRecaptchaWidget").firstChild) {
            this.idWidgetRecaptchaToken = window.grecaptcha.enterprise.render(
              "btnRecaptchaRegister",
              {
                sitekey: "6LeV4zcpAAAAADEJ3-lMqwX3l2TZDFybfhadIvVM",
                callback: "onCallbackRecaptchaRegister",
                "expired-callback": "onExpiredCallbackRecaptchaRegister",
                "error-callback": "onErrorCallbackRecaptchaRegister",
              }
            );

            this.startListenerEventsRecaptchaWidget();
          }
        }
      });
    },
    startListenerEventsRecaptchaWidget() {
      if (window.grecaptcha) {
        document.addEventListener("recaptchaToken", (event) => {
          this.recaptchaTokenRegister = event.detail;
        });

        document.addEventListener("expiredErrorRecaptchaToken", (event) => {
          // Error vindo null
          console.log("event error expired", event.detail);

          this.recaptchaTokenRegister = "";
          this.disabled = true;
          this.closeDialog();
        });

        document.addEventListener("errorRecaptchaToken", (event) => {
          console.log("event error general", event.detail);

          this.recaptchaTokenRegister = "";
          this.disabled = true;
          this.closeDialog();
        });
      }
    },
    capitalizeStr(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    // Limpa o formulário
    cancelForms() {
      if (this.$refs) {
        if (this.$refs.refFormRegister) {
          this.$refs.refFormRegister.reset();
          this.$refs.refFormRegister.resetValidation();
        }

        this.$refs.refEmail && this.$refs.refEmail.resetValidation();
      }
      this.affiliateName = "";
      this.promoCode.success.message = "";
      this.checkPasswordRules(true);
      this.disabled = true;
      this.recaptchaTokenRegister = "";
      window.grecaptcha.enterprise.reset(this.idWidgetRecaptchaToken);
    },
    closeDialog() {
      this.$store.commit("showDialogRegister", false);
    },
    debouncedInitialFormSetup() {
      clearInterval(this.initialFormSetupTimeoutId);

      this.initialFormSetupTimeoutId = setTimeout(() => {
        this.initialFormSetup();
      }, 1000);
    },
  },
};
</script>
<style>
.field {
  font-size: 0.95em;
}

#form
  .v-text-field
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  .v-label {
  font-size: 1.1em;
}

#form .v-input__append-inner {
  margin: auto;
}

.tooltip {
  width: 260px !important;
}
</style>
